import C from "@/components/NoticeBlock.module.css";

import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";

const iconColors = {
    primary: "color-primary",
    error: "color-error",
    success: "color-success",
};

export interface NoticeBlockProps extends BaseProps {
    children: ReactNode;

    color?: "primary" | "error" | "success";
    icon?: string;
    button?: ReactNode | ReactNode[];
    compact?: boolean;
    full?: boolean;
}

export function NoticeBlock({ children, color = "primary", icon, button, compact, full, ...props }: NoticeBlockProps) {
    let buttons: ReactNode[] = [];
    if (button) {
        buttons = Array.isArray(button) ? button : [button];
    }
    return (
        <div {...mcn(cn(C.NoticeBlock, C[color], compact && C.compact, full && C.full), props)}>
            {icon ? <MaskIcon className={cn(icon, C.Icon, iconColors[color])} /> : null}
            <div className={C.Content}>{children}</div>
            {buttons.map((button, index) => (
                <div key={index} className={C.Button}>
                    {button}
                </div>
            ))}
        </div>
    );
}
